





































































































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { ContractorNew as IContractorNew } from "@/api/models/contractor-new";
import {
  PhysicalContractorEdit,
  PhysicalContractorEdit as IPhysicalContractorEdit,
  PhysicalContractorEditTypeEnum
} from "@/api/models/physical-contractor-edit";
import {
  JuridicalContractorEdit,
  JuridicalContractorEdit as IJuridicalContractorEdit,
  JuridicalContractorEditTypeEnum
} from "@/api/models/juridical-contractor-edit";
import OrderItemPreview from "@/components/orders/OrderItemPreview.vue";
import { LearningRequest as ILearningRequest } from "@/api/models/learning-request";
import {
  currentUserIsCompanyOwner,
  getCurrentCompanyId,
  getCurrentEmployee,
  getCurrentUserId,
  isRoot
} from "@/plugins/roles";
import CustomTable from "@/components/form/CustomTable.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import TextField from "@/components/form/CustomPage/textField.vue";
import { OrdersListClass } from "@/classes/list/OrdersListClass";
import { LearningRequestSort, SortFields } from "@/plugins/sort-fields";
import StudentTable from "@/components/students/StudentTable.vue";

import {
  ContractorNewEdit as IContractorNewEdit,
  ContractorNewEditTypeEnum
} from "@/api/models";
import { Student as IStudent } from "@/api-v2/course/models";

@Component({
  components: {
    StudentTable,
    TextField,
    CBlock,
    CustomButton,
    CustomTable,
    OrderItemPreview
  }
})
export default class ContractorItem extends Vue {
  checkedStudents: IStudent[] = [];
  params: IContractorNewEdit = {
    type: ContractorNewEditTypeEnum.Physical,
    companyId: this.currentCompany(),
    phone: "",
    email: "",
    studentIds: []
  };

  physParams: PhysicalContractorEdit = {
    firstName: "",
    lastName: "",
    middleName: "",
    type: PhysicalContractorEditTypeEnum.Physical,
    companyId: this.currentCompany(),
    phone: "",
    email: "",
    responsibleId: this.currentEmployee ? this.currentEmployee.id : "",
    studentIds: []
  };

  jurParams: JuridicalContractorEdit = {
    title: "",
    shortTitle: "",
    inn: "",
    legalAddress: "",
    factAddress: "",
    kpp: "",
    ogrn: "",
    paymentAccount: "",
    correspondentAccount: "",
    directorNameInitials: "",
    directorPositionGenitive: "",
    bank: "",
    bik: "",
    directorName: "",
    directorNameGenitive: "",
    directorPosition: "",
    basis: "",
    type: JuridicalContractorEditTypeEnum.Juridical,
    companyId: this.currentCompany(),
    phone: "",
    email: "",
    responsibleId: this.currentEmployee ? this.currentEmployee.id : null,
    studentIds: []
  };

  @Prop() contractor!:
    | IContractorNew
    | IPhysicalContractorEdit
    | IJuridicalContractorEdit;
  physContractor!: IPhysicalContractorEdit;
  jurContractor!: IJuridicalContractorEdit;
  showSpinner: boolean = false;
  requests: Array<ILearningRequest> = [];
  limit: number = 30;
  offset: number = 0;
  sorted: SortFields<LearningRequestSort> = new SortFields(
    LearningRequestSort.formedAt
  );

  ordersList: OrdersListClass = new OrdersListClass({
    sort: this.sorted.sort,
    order: this.sorted.order,
    limit: 999,
    //@ts-ignore
    contractorId: this.contractor?.id ? this.contractor?.id : undefined,
    //@ts-ignore
    companyId: this.contractor?.company?.id,
    responsibleId:
      this.root || this.companyOwnerInContractor
        ? undefined
        : this.currentEmployee?.id
  });
  selectable: boolean = false;

  data() {
    return {
      physContractor: undefined,
      jurContractor: undefined
    };
  }

  get currentCompany() {
    return getCurrentCompanyId;
  }

  detectGender() {
    if (this.physContractor.gender == 0) {
      return this.$tc(this.$translate.Male);
    } else {
      return this.$tc(this.$translate.Female);
    }
  }

  get userId() {
    return getCurrentUserId();
  }

  get currentEmployee() {
    return getCurrentEmployee();
  }

  get companyOwnerInContractor() {
    //@ts-ignore
    return this.contractor?.company.owner.id === this.userId;
  }

  acceptSort(sort: LearningRequestSort) {
    this.sorted.changeSort(sort);
    this.ordersList.params = {
      limit: 999,
      sort: this.sorted.sort,
      order: this.sorted.order,
      //@ts-ignore
      contractorId: this.contractor?.id ? this.contractor?.id : undefined,
      //@ts-ignore
      companyId: this.contractor?.company?.id,
      responsibleId:
        this.root || this.companyOwnerInContractor
          ? undefined
          : this.currentEmployee.id
    };
    this.ordersList.sort();
  }

  get sortStatus() {
    return LearningRequestSort;
  }

  get selectedCompanyId() {
    return getCurrentCompanyId();
  }

  get root() {
    return isRoot();
  }

  get companyOwner() {
    return currentUserIsCompanyOwner();
  }

  instanceOfPhysicalContractor(
    object: IPhysicalContractorEdit | IJuridicalContractorEdit | IContractorNew
  ): object is IPhysicalContractorEdit {
    return object.type === "physical";
  }

  instanceOfJurContractor(
    object: IPhysicalContractorEdit | IJuridicalContractorEdit | IContractorNew
  ): object is IJuridicalContractorEdit {
    return object.type === "juridical";
  }

  @Watch("contractor")
  updateContractor() {}

  mounted() {
    if (this.instanceOfPhysicalContractor(this.contractor)) {
      this.physContractor = this.contractor;
      console.log(this.physContractor?.studentIds);
    } else {
      //@ts-ignore
      this.jurContractor = this.contractor;
    }
  }
}
